import AdminPageShell, { type AdminPageShellProps } from '../admin/AdminPageShell';
import { APPRENANT_HERO_BACKGROUND } from '../admin/AdminPageHero';

export type { AdminPageHeroSideCard } from '../admin/AdminPageShell';

export type ApprenantPageShellProps = Omit<AdminPageShellProps, 'backgroundImage'>;

/**
 * Enveloppe des pages apprenant : même hero que l’admin, fond `hero-banner-2.jpg`.
 */
export default function ApprenantPageShell(props: ApprenantPageShellProps) {
  return <AdminPageShell {...props} backgroundImage={APPRENANT_HERO_BACKGROUND} />;
}
